export enum FILE_TYPES {
	Others = 0,
	PhotoOfCurrentId = 1,
	Selfie = 2,
	ResidentialAddress = 3,
	ProofOfIncome = 4,
	SourceOfWealth = 5,
	InActiveAccount = 6,
	BankStatement = 7,
	ReservationForm = 8,
	ContractOfExchange = 9,
	TitleFloor = 10,
	UkFinance = 11,
	ProofOfDeposit = 12,
	SurveyorReport = 13,
	ReportOnTitle = 14,
	ExistingMortgage = 15,
	ExistingTenancy = 16,
	Ews1Form = 17,
	ValuationReport = 18,
	EnergyPerformance = 19,
	InactivateUser = 20,
	ChangeRequestDoc = 21,
	Fsa = 22,
	ChineseIdImgFront = 23,
	ChineseIdImgBack = 24,
	BankCardImg = 25,
	FunderIndividualOthers = 26,
	BorrowerIndividualOthers = 27,
	ChangeRequest = 28,
	CertificateOfIncorporation = 29
}

export const FILE_TYPE_NAME = {
	identityFiles: 'Photo of current HKID/Passport/Driver License with Photo',
	selfie: 'Selfie',
	proofOfIncome: 'Proof of Income',
	sourceOfWealth: 'Source of Wealth',
	residentialAddrProof: 'Residential Address Proof',
	otherDocs: 'Other Documents',
	bankStatement: 'Bank Statements for the past 3 months',
	reservationFormOrMm: 'Reservation Form or Memorandum of Sale',
	contractOfExchange: 'Contract of Exchange',
	titleFloorPlan: 'Title Floor Plan',
	ukFinance: 'U.K. Finance Disclosure Form',
	proofOfDeposit: 'Proof of Deposit',
	surveyorReport: 'Surveyor Report',
	reportOnTitle: 'Report on Title / Title Deed',
	existingMortgage: 'Existing Mortgage Statements/Rent Roll',
	existingTenancy: 'Existing Tenancy Agreement/Leasing Contract',
	energyPerformance: 'Energy Performance Certificate',
	ews1Form: 'EWS1 Form',
	validationReport: 'Valuation Report',
	changeRequestDoc: 'Change Request Document',
	fsa: 'Funder Service Agreement',
	chineseIdImgFront: 'Chinese identification Image Front',
	chineseIdImgBack: 'Chinese identification Image Back',
	bankCardImg: 'Bank Card Image',
	funderIndividualOthers: 'Other Documents',
	borrowerIndividualOthers: 'Other Documents',
	changeRequest: 'Change Request',
	certificateOfIncorporation: 'Certificate of Incorporation'
};

const fileTypeMappers = new Map<FILE_TYPES, string>();
fileTypeMappers.set(FILE_TYPES.PhotoOfCurrentId, FILE_TYPE_NAME.identityFiles);
fileTypeMappers.set(FILE_TYPES.Selfie, FILE_TYPE_NAME.selfie);
fileTypeMappers.set(FILE_TYPES.ResidentialAddress, FILE_TYPE_NAME.residentialAddrProof);
fileTypeMappers.set(FILE_TYPES.ProofOfIncome, FILE_TYPE_NAME.proofOfIncome);
fileTypeMappers.set(FILE_TYPES.SourceOfWealth, FILE_TYPE_NAME.sourceOfWealth);
fileTypeMappers.set(FILE_TYPES.BankStatement, FILE_TYPE_NAME.bankStatement);
fileTypeMappers.set(FILE_TYPES.ReservationForm, FILE_TYPE_NAME.reservationFormOrMm);
fileTypeMappers.set(FILE_TYPES.ContractOfExchange, FILE_TYPE_NAME.contractOfExchange);
fileTypeMappers.set(FILE_TYPES.TitleFloor, FILE_TYPE_NAME.titleFloorPlan);
fileTypeMappers.set(FILE_TYPES.UkFinance, FILE_TYPE_NAME.ukFinance);
fileTypeMappers.set(FILE_TYPES.ProofOfDeposit, FILE_TYPE_NAME.proofOfDeposit);
fileTypeMappers.set(FILE_TYPES.SurveyorReport, FILE_TYPE_NAME.surveyorReport);
fileTypeMappers.set(FILE_TYPES.ReportOnTitle, FILE_TYPE_NAME.reportOnTitle);
fileTypeMappers.set(FILE_TYPES.ExistingMortgage, FILE_TYPE_NAME.existingMortgage);
fileTypeMappers.set(FILE_TYPES.ExistingTenancy, FILE_TYPE_NAME.existingTenancy);
fileTypeMappers.set(FILE_TYPES.EnergyPerformance, FILE_TYPE_NAME.energyPerformance);
fileTypeMappers.set(FILE_TYPES.Ews1Form, FILE_TYPE_NAME.ews1Form);
fileTypeMappers.set(FILE_TYPES.ValuationReport, FILE_TYPE_NAME.validationReport);
fileTypeMappers.set(FILE_TYPES.Others, FILE_TYPE_NAME.otherDocs);

fileTypeMappers.set(FILE_TYPES.ChangeRequestDoc, FILE_TYPE_NAME.changeRequestDoc);
fileTypeMappers.set(FILE_TYPES.Fsa, FILE_TYPE_NAME.fsa);
fileTypeMappers.set(FILE_TYPES.ChineseIdImgFront, FILE_TYPE_NAME.chineseIdImgFront);
fileTypeMappers.set(FILE_TYPES.ChineseIdImgBack, FILE_TYPE_NAME.chineseIdImgBack);
fileTypeMappers.set(FILE_TYPES.BankCardImg, FILE_TYPE_NAME.bankCardImg);
fileTypeMappers.set(FILE_TYPES.FunderIndividualOthers, FILE_TYPE_NAME.funderIndividualOthers);
fileTypeMappers.set(FILE_TYPES.BorrowerIndividualOthers, FILE_TYPE_NAME.borrowerIndividualOthers);
fileTypeMappers.set(FILE_TYPES.ChangeRequest, FILE_TYPE_NAME.changeRequest);
fileTypeMappers.set(FILE_TYPES.CertificateOfIncorporation, FILE_TYPE_NAME.certificateOfIncorporation);

export const FILE_TYPE_MAPPER = fileTypeMappers;

export enum CORPORATE_FILE_TYPE {
	Others = 0,
	CertificateOfIncorporation = 1,
	BusinessRegistrationCertification = 2,
	LatestAnnualReturn = 3,
	CertificateOfIncumbency = 4,
	LatestAuditedFinancialStatement = 5,
	GroupOwnership = 6,
	signedBoardResolution = 7,
	Fsa = 8,
	FunderCorporateOthers = 9,
	BorrowerCorporateOthers = 10,
	ChangeRequest = 11
}

export const CORPORATE_FILE_TYPE_NAME = {
	businessRegistrationCertification: 'Business Registration Certification',
	certificateOfIncorporation: 'Certificate of Incorporation',
	certificateOfIncumbency: 'Certificate of Incumbency',
	groupOwnership: 'Group Ownership',
	latestAnnualReturn: 'Latest Annual Return',
	latestAuditedFinancialStatement: 'Latest Audited Financial Statement',
	others: 'Other Documents',
	signedBoardResolution: 'Singed Board Resolution',

	fsa: 'Funder Service Agreement',
	funderCorporateOthers: 'Other Documents',
	borrowerCorporateOthers: 'Other Documents',
	changeRequest: 'Change Request'
};

const coporateTypeMapper = new Map<CORPORATE_FILE_TYPE, string>();
coporateTypeMapper.set(
	CORPORATE_FILE_TYPE.BusinessRegistrationCertification,
	CORPORATE_FILE_TYPE_NAME.businessRegistrationCertification
);
coporateTypeMapper.set(
	CORPORATE_FILE_TYPE.CertificateOfIncorporation,
	CORPORATE_FILE_TYPE_NAME.certificateOfIncorporation
);
coporateTypeMapper.set(CORPORATE_FILE_TYPE.Others, CORPORATE_FILE_TYPE_NAME.others);
coporateTypeMapper.set(CORPORATE_FILE_TYPE.LatestAnnualReturn, CORPORATE_FILE_TYPE_NAME.latestAnnualReturn);
coporateTypeMapper.set(CORPORATE_FILE_TYPE.CertificateOfIncumbency, CORPORATE_FILE_TYPE_NAME.certificateOfIncumbency);
coporateTypeMapper.set(
	CORPORATE_FILE_TYPE.LatestAuditedFinancialStatement,
	CORPORATE_FILE_TYPE_NAME.latestAuditedFinancialStatement
);
coporateTypeMapper.set(CORPORATE_FILE_TYPE.signedBoardResolution, CORPORATE_FILE_TYPE_NAME.signedBoardResolution);
coporateTypeMapper.set(CORPORATE_FILE_TYPE.GroupOwnership, CORPORATE_FILE_TYPE_NAME.groupOwnership);

coporateTypeMapper.set(CORPORATE_FILE_TYPE.Fsa, CORPORATE_FILE_TYPE_NAME.fsa);
coporateTypeMapper.set(CORPORATE_FILE_TYPE.FunderCorporateOthers, CORPORATE_FILE_TYPE_NAME.funderCorporateOthers);
coporateTypeMapper.set(CORPORATE_FILE_TYPE.BorrowerCorporateOthers, CORPORATE_FILE_TYPE_NAME.borrowerCorporateOthers);
coporateTypeMapper.set(CORPORATE_FILE_TYPE.ChangeRequest, CORPORATE_FILE_TYPE_NAME.changeRequest);

export const CORPORATE_FILE_TYPE_MAPPER = coporateTypeMapper;

export enum documentListTypeEnum {
	platformUsageDisclaimer = 'platformUsageDisclaimer',
	termsAndConditions = 'termsAndConditions',
	PersonalDataPrivacyPolicy = 'PersonalDataPrivacyPolicy',
	declarationForm = 'declarationForm',
	personalInformationCollectionStatement = 'personalInformationCollectionStatement',
	professionalInvestorNotice = 'professionalInvestorNotice',
	borrowerRequestCorporate = 'borrowerRequestCorporate',
	funderRequest = 'funderRequest'
}

export const documentListType = {
	platformUsageDisclaimer: 'PUD',
	termsAndConditions: 'TC',
	PersonalDataPrivacyPolicy: 'PDPP',
	declarationForm: 'DF',
	personalInformationCollectionStatement: 'PICS',
	professionalInvestorNotice: 'PIN',
	borrowerRequestCorporate: 'BGR',
	funderRequest: 'FR'
};

const documentTypeMapper = new Map<string, string>();

documentTypeMapper.set(documentListTypeEnum.platformUsageDisclaimer, documentListType.platformUsageDisclaimer);
documentTypeMapper.set(documentListTypeEnum.termsAndConditions, documentListType.termsAndConditions);
documentTypeMapper.set(documentListTypeEnum.PersonalDataPrivacyPolicy, documentListType.PersonalDataPrivacyPolicy);
documentTypeMapper.set(documentListTypeEnum.declarationForm, documentListType.declarationForm);
documentTypeMapper.set(
	documentListTypeEnum.personalInformationCollectionStatement,
	documentListType.personalInformationCollectionStatement
);
documentTypeMapper.set(documentListTypeEnum.professionalInvestorNotice, documentListType.professionalInvestorNotice);
documentTypeMapper.set(documentListTypeEnum.borrowerRequestCorporate, documentListType.borrowerRequestCorporate);
documentTypeMapper.set(documentListTypeEnum.funderRequest, documentListType.funderRequest);

export const DOCUMENT_TYPE_MAPPER = documentTypeMapper;
